import React, {Component} from 'react';
import $ from 'jquery';
import './ion-slider/js/ion.rangeSlider';
import './ion-slider/css/ion.rangeSlider.css';

import PropTypes from 'prop-types';

class Slider extends Component {

    slider = null;

    componentWillReceiveProps(nextProps) {
        if (nextProps.resetTime !== this.props.resetTime) {
            this.slider.update({
                from: this.props.min,
                to: this.props.max,
            });
        }
    }

    componentWillUnmount() {
        this.slider.destroy();
        this.slider = null;
    }

    componentDidMount() {
        const id = `slider-${this.props.id}`;
        $('#' + id).ionRangeSlider({
            type: 'double',
            skin: 'round',
            grid: true,
            hide_min_max: true,
            min: this.props.min || 0,
            max: this.props.max || 0,
            prefix: this.props.pre ? '$' : null,
            postfix: this.props.post ? '"' : null,
            from: this.props.from || 0,
            to: this.props.to || this.props.max,
            step: this.props.step ? this.props.step : 1,
            onChange: (data) => {
                this.props.onChange(data);
            },

            onUpdate: (data) => {
                this.props.onChange(data);
            },
        });
        this.slider = $('#' + id).data('ionRangeSlider');
    }


    render() {
        return (
            <div>
                <input id={`slider-${this.props.id}`} type='text' />
            </div>
        );
    }
}

Slider.propTypes = {
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    from: PropTypes.number,
    to: PropTypes.number,
    id: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    pre: PropTypes.bool,
    post: PropTypes.bool,
    step: PropTypes.number,
    resetTime: PropTypes.object,
};

Slider.defaultProps = {
    pre: false,
    post: false,
};

export default Slider;


// WEBPACK FOOTER //
// ./src/common/Slider.js